// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import store from './store/index';
import axios from './axios'
//import MultiLanguage from 'vue-multilanguage'
import VeeValidate from 'vee-validate';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment';

Vue.use(ElementUI)
Vue.use(VeeValidate, { fieldsBagName: 'fieldBags' });

Vue.prototype.$moment = moment
Vue.prototype.$http = axios

// 引入翻译
require('./language/index')
require("babel-polyfill"); //  兼容ie9

Vue.config.productionTip = false

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

export default vm;



// WEBPACK FOOTER //
// ./src/main.js